/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomEmailSettings200ResponseSettings } from './GetCustomEmailSettings200ResponseSettings';
import {
    GetCustomEmailSettings200ResponseSettingsFromJSON,
    GetCustomEmailSettings200ResponseSettingsFromJSONTyped,
    GetCustomEmailSettings200ResponseSettingsToJSON,
    GetCustomEmailSettings200ResponseSettingsToJSONTyped,
} from './GetCustomEmailSettings200ResponseSettings';

/**
 * 
 * @export
 * @interface GetCustomEmailSettings200Response
 */
export interface GetCustomEmailSettings200Response {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    settings?: GetCustomEmailSettings200ResponseSettings;
}

/**
 * Check if a given object implements the GetCustomEmailSettings200Response interface.
 */
export function instanceOfGetCustomEmailSettings200Response(value: object): value is GetCustomEmailSettings200Response {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetCustomEmailSettings200ResponseFromJSON(json: any): GetCustomEmailSettings200Response {
    return GetCustomEmailSettings200ResponseFromJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomEmailSettings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'settings': json['settings'] == null ? undefined : GetCustomEmailSettings200ResponseSettingsFromJSON(json['settings']),
    };
}

export function GetCustomEmailSettings200ResponseToJSON(json: any): GetCustomEmailSettings200Response {
    return GetCustomEmailSettings200ResponseToJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseToJSONTyped(value?: GetCustomEmailSettings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'settings': GetCustomEmailSettings200ResponseSettingsToJSON(value['settings']),
    };
}

